import { useEffect, useRef } from 'react';
// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function usePrevious(value: any) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
